// Game configuration interface
export interface GameConfig {
  priceGridSize: number; // Price grid size (USD)
  priceUpdateRate: number; // Price update frequency (milliseconds)
  xAxisRange: number; // X-axis range
  minXAxis: number; // X-axis minimum value
  moveSpeedOnXAxis: number; // X-axis movement speed
  betAmount: number; // Bet amount per bet
  distanceMultiplier: number; // Distance multiplier for calculating odds
}

// Price point interface (for drawing lines)
export interface PricePoint {
  x: number;
  y: number;
  price: number;
  timestamp: number;
}

// Highlight square interface
export interface HighlightSquare {
  x: number;
  y: number;
  timestamp: number;
  hit?: boolean; // Whether it has been hit
  hitTime?: number; // Hit time
  betAmount: number; // Bet amount
  winAmount?: number; // Win amount
  multiplier: number; // Multiplier
}

// Bet status enumeration
export enum BetStatus {
  PENDING = "pending", // Bet not executed
  MISS = "miss", // Missed
  HIT = "hit", // Hit
}

// Bet record interface
export interface BetRecord {
  id: string;
  timestamp: number;
  betAmount: number;
  targetPrice: number;
  targetTime: number;
  status: BetStatus; // Use new status enumeration
  hit: boolean; // Maintain backward compatibility
  winAmount?: number;
  balanceAfterBet: number;
  balanceAfterResult: number;
  multiplier: number; // Multiplier
}

// DOM elements interface
export interface GameElements {
  gridContainer: HTMLElement | null;
  currentPriceEl: HTMLElement | null;
  balanceEl: HTMLElement | null;
  historyPanelEl: HTMLElement | null;
  historyListEl: HTMLElement | null;
  betAmountEl: HTMLElement | null;

  gridSizeSlider: HTMLInputElement | null;
  gridSizeValue: HTMLElement | null;
  distanceMultiplierInput: HTMLInputElement | null; // Distance multiplier input field
}

// Game state enumeration
export enum GameState {
  IDLE = "idle",
  RUNNING = "running",
  PAUSED = "paused",
}

// Price fetch status
export interface PriceFetchStatus {
  isConnected: boolean;
  lastUpdate: number;
  errorCount: number;
  lastError?: string;
}
